import qs from 'qs'
import request from '@/utils/request'

// 接入方管理接口（/qw-admin/app/*，对应后端 QiWeiAppController）
// 接入方 = 需要读取会话存档的外部系统，凭 appId/appSecret 调用 /qw-archive 系列接口

// 接入方列表（含密钥，仅管理端可见）
export function getAppList () {
    return request({
        url: '/qw-admin/app/list',
        method: 'post'
    })
}

// 新增接入方：appSecret 不传自动生成 40 位随机串；chatIds 逗号分隔，空 = 全部群
export function addApp (data) {
    return request({
        url: '/qw-admin/app/add',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 更新接入方：chatIds 传空串 = 改为全部群；status 1 启用 0 停用
export function updateApp (data) {
    return request({
        url: '/qw-admin/app/update',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 重置密钥：旧密钥即刻吊销，返回新密钥（发给接入方）
export function resetAppSecret (id) {
    return request({
        url: '/qw-admin/app/resetSecret',
        method: 'post',
        data: qs.stringify({ id })
    })
}

// 删除接入方（慎用，一般用停用代替）
export function deleteApp (id) {
    return request({
        url: '/qw-admin/app/delete',
        method: 'post',
        data: qs.stringify({ id })
    })
}
